<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-content">
          <div class="tabs-container">
            <ul class="nav nav-tabs" role="tablist">
              <li [class.active]="activeTab() === 'check'">
                <a role="tab"
                   [attr.aria-selected]="activeTab() === 'check'"
                   href="javascript:void(0)"
                   (click)="setActiveTab('check')">
                  <i class="fa fa-search"></i> Image Check
                </a>
              </li>
              <li [class.active]="activeTab() === 'sync'">
                <a role="tab"
                   [attr.aria-selected]="activeTab() === 'sync'"
                   href="javascript:void(0)"
                   (click)="setActiveTab('sync')">
                  <i class="fa fa-refresh"></i> Image Sync
                </a>
              </li>
            </ul>
            <div class="tab-content">
              @if (activeTab() === 'check') {
              <div class="tab-pane active">
                <div class="panel-body">
                  <app-image-check></app-image-check>
                </div>
              </div>
              }
              @if (activeTab() === 'sync') {
              <div class="tab-pane active">
                <div class="panel-body">
                  <app-image-sync></app-image-sync>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
